export default {
    nl: {
        intro: {
            subtitle: 'Wireframing & prototyping',
            title: 'Een goed begin.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/wireframing/hero.jpg',
        },
        type: 'Wireframing & prototyping',
        title: 'Breng ideeën tot leven met onze wireframing & prototyping',
        description:
            'Ontdek de kracht van onze wireframing en prototyping bij het vormen van interactieve, gebruiksvriendelijke digitale ontwerpen',
        content: [
            {
                type: 'text',
                title: 'Wireframing & Prototyping',
                content:
                    'Wireframing is de basis van een goed ontwerp van een digitaal product. Je kunt het vergelijken met het leggen van een fundament van een gebouw. We kunnen nog tal van metaforen bedenken voor wireframing, maar in het kort komt het erop neer dat het de krachtigste methode is waarmee we de structuur, functionaliteit en gebruikerservaring van een digitaal product in grove lijnen visualiseren voordat we beginnen het maken van een prototype, gevolgd door het <a href="/diensten/visual-design/">visual design</a> en het realiseren van het eindproduct.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/wireframe.png',
                ],
            },
            {
                type: 'text',
                title: 'Wireframes maken tijdens het ontwerpproces',
                content: `
                    Wireframing is een visuele weergave van de belangrijkste elementen en functionaliteiten van een digitaal product. Daarom start ons ontwerpproces altijd met wireframes. Wireframes zijn minimalistisch en richten zich op functionaliteit in plaats van look and feel. Ze stellen ons in staat om snel ideeën te visualiseren en potentiële problemen in een vroeg stadium te identificeren. Hier komt de essentie van <a href="/diensten/ux-research/">UX research</a> naar voren, waarbij onderzoek en analyse een leidraad vormen om de behoeften en voorkeuren van gebruikers goed te begrijpen.
                `,
            },
            {
                type: 'text',
                title: 'Prototype maken voor het optimale eind resultaat',
                content: `
                    De wireframes samen vormen zich tot een prototype. Prototypen draait om het weergeven van interacties tussen en op pagina’s. Op deze manier ontstaat er een user flow in een product dat we kunnen testen met eindgebruikers. Dit is een belangrijke fase in het UI/UX design proces, waarbij het prototype helpt als een interactief model van het eindproduct. Feedback van gebruikers tijdens user testing wordt hierbij verzameld om optimalisaties snel door te voeren.
                `,
            },
            {
                type: 'image-big',
                image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/meeting-planning.webp',
            },
        ],
        related_services: ['design-system', 'visual-design', 'ux-research'],
        contact: {
            title: '',
            employee: 'robert',
        },
    },
    en: {},
};
